import type {
    ExtendedVariableValue,
    SerializedVariable,
    SerializedVariablesList,
    SerializedVariantRelation
} from '../types'

export interface VariableDefaultValue {
    name: string
    value: unknown
}

export interface IVariableDefaultsExtractor {
    extractDefaults(variablesData: SerializedVariablesList): Record<string, unknown>
}

export class VariableDefaultsExtractor implements IVariableDefaultsExtractor {
    extractDefaults(variablesData: SerializedVariablesList): Record<string, unknown> {
        const defaultValues = variablesData.variables
            .map(variable => this.extractDefaultFromVariable(variable))
            .filter((item): item is VariableDefaultValue => item !== null)

        return Object.fromEntries(defaultValues.map(({name, value}) => [name, value]))
    }

    private extractDefaultFromVariable(variable: SerializedVariable): VariableDefaultValue | null {
        if (!variable.name) {
            return null
        }

        const defaultValueItem = variable.value.values.find(this.isDefaultValue)

        if (!defaultValueItem?.value) {
            return null
        }

        return {
            name: variable.name,
            value: defaultValueItem.value
        }
    }

    private isDefaultValue(item: ExtendedVariableValue | SerializedVariantRelation): item is ExtendedVariableValue {
        return item.type !== 'VariantRelation'
    }
}
